// extracted by mini-css-extract-plugin
export default {"absence":"Reservation_absence__RnjCu"};